import { useTranslation } from 'react-i18next'
import type { BasePuiDialogProps } from '@pbt/pbt-ui-components'

import type { Prescription } from '~/types'

import type { PrescriptionEditorProps } from '../prescription-editor/hooks/usePrescriptionEditor'
import BasePrescriptionDialog from './BasePrescriptionDialog'

export interface DrugPrescriptionDialogProps extends BasePuiDialogProps {
  areChargesPostedAndEditable?: boolean
  clientId: string
  onSave: PrescriptionEditorProps['onSave']
  outsideSoap?: boolean
  patientId: string
  prescription: Prescription
  skipOrderFetching?: boolean
  soapId?: string
}

const DrugPrescriptionDialog = ({
  prescription,
  outsideSoap,
  clientId,
  patientId,
  soapId,
  open,
  skipOrderFetching,
  onClose,
  onSave,
  areChargesPostedAndEditable,
}: DrugPrescriptionDialogProps) => {
  const { t } = useTranslation('Dialogs')
  const automaticallyCreateTaskLabel = t(
    'Dialogs:PRESCRIPTION_DIALOG.AUTOMATICALLY_CREATE_TASK_TO_ADMINISTER',
  )

  return (
    <BasePrescriptionDialog
      showDiscussedWithClient
      areChargesPostedAndEditable={areChargesPostedAndEditable}
      automaticallyCreateTaskLabel={automaticallyCreateTaskLabel}
      clientId={clientId}
      open={open}
      outsideSoap={outsideSoap}
      patientId={patientId}
      prescription={prescription}
      skipOrderFetching={skipOrderFetching}
      soapId={soapId}
      onClose={onClose}
      onSave={onSave}
    />
  )
}

export default DrugPrescriptionDialog
